import { baseUrlApi } from '../../config';
import React, { useState } from "react";
import { useEffect } from "react";
import {
    Box,
    Tooltip,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    Button,
    Flex,
    Text,
    Textarea,
    Image,
    useMediaQuery
} from "@chakra-ui/react";
import { MdNoteAdd } from "react-icons/md";
import { IoMdSend } from "react-icons/io";
import { GrNotes } from "react-icons/gr";
import { FaTrash, FaFileDownload } from "react-icons/fa";
import FileUpload from "../FileUpload";
import { useUsuarios } from "../../hooks/useUsuarios";


const Notas = ({ handleAddObs, idVenda, textObs, observacoes, handleApagarObs, gatilho }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [notas, setNotas] = useState(observacoes || []);
    const [localTextObs, setLocalTextObs] = useState("");
    const [isMobile] = useMediaQuery("(max-width: 768px)");
    const [files, setFiles] = useState([]);
    const usuarios = useUsuarios();

    useEffect(() => {
        setNotas(observacoes || []);
    }, [observacoes]);

    const openModal = () => setIsOpen(true);
    const closeModal = () => setIsOpen(false);

    const handleSaveNota = () => {
        handleAddObs(idVenda, localTextObs, files);
        setLocalTextObs("");
        setFiles([]);
    };

    const handleDeleteNota = (id) => {
        setNotas(notas.filter((nota) => nota.id !== id));
        handleApagarObs(idVenda, id);
    };

    const podeExcluirObs = (usuario_id) => {
        const userString = window.localStorage.getItem("user");
        const user = JSON.parse(userString);
        if (user.id == usuario_id) {
            return true;
        }
        return false;
    };

    const formataCreatedAt = (data) => {
        const date = new Date(data);
        const offset = -3 * 60;
        const brasiliaDate = new Date(date.getTime() + (offset + date.getTimezoneOffset()) * 60000);

        const day = brasiliaDate.getDate().toString().padStart(2, '0');
        const month = (brasiliaDate.getMonth() + 1).toString().padStart(2, '0');
        const year = brasiliaDate.getFullYear();
        const hours = brasiliaDate.getHours().toString().padStart(2, '0');
        const minutes = brasiliaDate.getMinutes().toString().padStart(2, '0');
        const formattedDateTime = `${day}/${month}/${year} ${hours}:${minutes}`;
        return formattedDateTime;
    }


    const isImage = (fileName) => {
        const imageExtensions = ['png', 'jpg', 'jpeg'];
        const fileExtension = fileName.toLowerCase().split('.').pop();
        console.log("fileExtension = ", fileExtension)
        console.log("e iimg ? = ", imageExtensions.includes(fileExtension))
        return imageExtensions.includes(fileExtension);
    };


    const getImgUser = (usuario_id) => {
        var img = "user.png";
        if (usuario_id == 3) {
            img = "/gabriel_logo.webp";
        } else if (usuario_id == 5) {
            img = "/tilio_logo.webp";
        } else if (usuario_id == 6) {
            img = "/riccioppo_logo.webp";
        } else if (usuario_id == 7) {
            img = "/user.png";
        } else if (usuario_id == 8) {
            img = "/gabriel_valiente_logo.webp";
        } else if (usuario_id == 9) {
            img = "/emerson_vendedor_logo.webp";
        }else if (usuario_id == 10) {
            img = "/analuiza_logo.webp";
        }
        
        return img;
    };

    const getNomeUser = (usuario_id) => {
        const usuario = usuarios.find((u) => u.id == usuario_id);
        return usuario ? usuario.name : "TAGA ADM";
    };

    return (
        <>
            {
                gatilho ? gatilho({ abrir: openModal, quantidade: notas.length }) :
                isMobile ?
                    (
                        <Tooltip label={notas.length > 0 ? "Visualizar Observações" : "Adicionar Observações"}>
                            <Box
                                className={notas.length > 0 ? "vibrate-notas" : ""}
                                bg={notas.length > 0 ? "#F68633" : "gray.300"}
                                w="45px"
                                h="45px"
                                borderRadius="50%"
                                display="flex"
                                alignItems="center"
                                justifyContent="center"
                                mr={4}
                                mb={0}
                                cursor="pointer"
                                position="relative"
                                transition="all 0.2s ease-in-out"
                                _hover={{
                                    bg: notas.length > 0 ? "#F68633" : "gray.400",
                                    transform: "scale(1.2)",
                                }}
                                onClick={openModal}
                            >
                                {notas.length > 0 && (
                                    <Box
                                        position="absolute"
                                        top="-6px"
                                        right="-6px"
                                        bg="red.500"
                                        color="white"
                                        fontSize="0.8rem"
                                        fontWeight="bold"
                                        w="15px"
                                        h="15px"
                                        display="flex"
                                        alignItems="center"
                                        justifyContent="center"
                                        borderRadius="50%"
                                        boxShadow="md"
                                    >
                                        {notas.length}
                                    </Box>
                                )}
                                {notas.length > 0 ? (
                                    <GrNotes fontSize="1rem" color="white" />
                                ) : (
                                    <MdNoteAdd fontSize="1.2rem" />
                                )}
                            </Box>
                        </Tooltip>
                    )
                    :
                    (
                        <Tooltip label={notas.length > 0 ? "Visualizar Observações" : "Adicionar Observações"}>
                            <Box
                                className={notas.length > 0 ? "vibrate-notas" : ""}
                                bg={notas.length > 0 ? "#F68633" : "gray.300"}
                                w="35px"
                                h="35px"
                                borderRadius="50%"
                                display="flex"
                                alignItems="center"
                                justifyContent="center"
                                mr={2}
                                mb={12}
                                cursor="pointer"
                                position="relative"
                                transition="all 0.2s ease-in-out"
                                _hover={{
                                    bg: notas.length > 0 ? "#F68633" : "gray.400",
                                    transform: "scale(1.2)",
                                }}
                                onClick={openModal}
                            >
                                {notas.length > 0 && (
                                    <Box
                                        position="absolute"
                                        top="-8px"
                                        right="-8px"
                                        bg="red.500"
                                        color="white"
                                        fontSize="0.8rem"
                                        fontWeight="bold"
                                        w="20px"
                                        h="20px"
                                        display="flex"
                                        alignItems="center"
                                        justifyContent="center"
                                        borderRadius="50%"
                                        boxShadow="md"
                                    >
                                        {notas.length}
                                    </Box>
                                )}
                                {notas.length > 0 ? (
                                    <GrNotes fontSize="1.2rem" color="white" />
                                ) : (
                                    <MdNoteAdd fontSize="1.5rem" />
                                )}
                            </Box>
                        </Tooltip>
                    )
            }
            <Modal isOpen={isOpen} onClose={closeModal} size="lg">
                <ModalOverlay zIndex="100" />
                <ModalContent zIndex="101">
                    <ModalHeader>Histórico de Observações</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <Flex flexDirection="column" mb={4}>
                            {notas && notas.map((nota) => (
                                <Flex key={nota.id} flexDirection="row" align="center" mb={2}>
                                    <Box>
                                        <Image
                                            boxShadow="lg"
                                            borderRadius="50%"
                                            src={getImgUser(nota.usuario_id)}
                                            alt={`imagem_${nota.usuario_id}`}
                                            maxW="30px"
                                            maxH="30px"
                                            mr={2}
                                        />
                                    </Box>
                                    <Box
                                        bg="gray.200"
                                        p={2}
                                        borderRadius="md"
                                        boxShadow="sm"
                                        flex="1"
                                        position="relative"
                                    >
                                        <Text fontSize="sm" fontWeight="bold">
                                            {getNomeUser(nota.usuario_id)}
                                        </Text>
                                        <Text fontSize="sm">{nota.observacao}</Text>
                                        <Flex mt={2} wrap="wrap" justify="flex-start">
                                            {nota.arquivos && nota.arquivos.map((arquivo, index) => (
                                                <Box key={index} m={1} position="relative">
                                                    {isImage(arquivo.file_name) ? (
                                                        <Image
                                                            src={baseUrlApi.replace('api', '') + 'storage/' + arquivo.file_path}
                                                            alt={`thumbnail_${arquivo.file_name}`}
                                                            boxSize="50px"
                                                            objectFit="cover"
                                                            borderRadius="md"
                                                            border="1px solid black"
                                                            cursor="pointer"
                                                            onClick={() => window.open(baseUrlApi.replace('api', '') + 'storage/' + arquivo.file_path, "_blank")}
                                                        />
                                                    ) : (
                                                        <Button
                                                            size="sm"
                                                            colorScheme="teal"
                                                            variant="outline"
                                                            m={1}
                                                            onClick={() => window.open(baseUrlApi.replace('api', '') + 'storage/' + arquivo.file_path, "_blank")}
                                                        >
                                                            <FaFileDownload /> <Text ml={1}>{arquivo.file_name}</Text>
                                                        </Button>
                                                    )}
                                                </Box>
                                            ))}
                                        </Flex>

                                        <Text fontSize="xs" color="gray.500">
                                            {formataCreatedAt(nota.created_at)}
                                        </Text>
                                        {
                                            podeExcluirObs(nota.usuario_id) && (
                                                <Tooltip label="Remover Observação">
                                                    <Button
                                                        size="xs"
                                                        colorScheme="red"
                                                        position="absolute"
                                                        top="5px"
                                                        right="5px"
                                                        onClick={() => handleDeleteNota(nota.id)}
                                                    // onClick={() => handleApagarObs(idVenda, nota.id)}
                                                    >
                                                        <FaTrash />
                                                    </Button>
                                                </Tooltip>
                                            )
                                        }
                                    </Box>
                                </Flex>
                            ))}
                        </Flex>

                        <Flex justify={"center"} align={"center"} flexDirection={"column"}>
                            <Text fontWeight="bold" mb={2}>Adicionar Observação</Text>
                            <FileUpload
                                files={files}
                                setFiles={setFiles}
                            />
                            <Textarea
                                mt={4}
                                value={localTextObs}
                                onChange={(e) => setLocalTextObs(e.target.value)} // Atualiza o estado local
                                placeholder="Escreva sua nota aqui..."
                                maxW="500px"
                                resize="none"
                            />

                            <Button
                                ml={2}
                                bg="#01695E"
                                color="white"
                                _hover={{
                                    bg: "white",
                                    color: "black",
                                    border: "1px solid #01695E",
                                    transition: "0.3s",
                                }}
                                onClick={handleSaveNota}
                                boxShadow="lg"
                                mt={4}
                                w="full"
                                display="flex"
                                alignItems="center"
                                justifyContent="center"
                            >
                                <Text mr={2} fontWeight="semibold">Adicionar</Text>
                                <IoMdSend fontSize="20px" />
                            </Button>
                        </Flex>
                    </ModalBody>

                </ModalContent>
            </Modal>
        </>
    );
};

export default Notas;
